import "./ErrorScreen.css";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import Translatable from "../Translatable/Translatable";

export default function ErrorScreen() {
  return (
    <div className="error-screen-container">
      <div className="error-alert-box">
      <SlIcon className="error-alert-icon" name="hdd-rack"></SlIcon>
        <div className="">
          <h2>
            <Translatable as="span" capitalize>Hubo un error.</Translatable>
          </h2>
          <p>
            <Translatable as="span">Alguno de los servicios puede no encontrarse disponible.</Translatable>
          </p>
        </div>
      </div>
    </div>
  );
}
